export const getParkingPermitDetail = (state) => state.ParkingPermitDetails;
